'use strict';

var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
var base = require('base/login/login');
var embroidery = require('org/product/embroidery');

var passwordResetTrigger = null;
var passwordResetAriaHiddenElements = [];

/**
 * Submits the login form to the Account-Login route
 * @param {JQuery} $form - the login form as a jQuery object
 * @param {string} url - the Account-Login route's url
 */
function login($form, url) {
    let formData = $form.serializeArray();
    let embroideryTemplatesData;

    // If guest user has saved embroidery templates send the data for saving on profile
    if (window.localStorage.getItem('savedEmbroideryTemplates')) {
        embroideryTemplatesData = embroidery.validateStoredTemplates();
        if (embroideryTemplatesData.length) {
            formData.push({
                name: 'savedEmbroideryTemplates',
                value: JSON.stringify(embroideryTemplatesData)
            });
        }
    }

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: formData,
        success: function (data) {
            $form.spinner().stop();
            if (!data.success) {
                formValidation($form, data);
                $('form.login').trigger('login:error', data);
            } else {
                // Delete guest saved templates upon logging in
                if (embroideryTemplatesData) {
                    window.localStorage.removeItem('savedEmbroideryTemplates');
                }
                if (data.cartMerged && data.cartMerged === true) {
                    // add query parameter to url
                    var urlObj = new URL(data.redirectUrl, document.location);
                    urlObj.searchParams.set('cartmerged', true);
                    data.redirectUrl = urlObj.href;
                }
                $('form.login').trigger('login:success', data);
                if (data.hashedEmail) {
                    localStorage.setItem('hash_customer_email', data.hashedEmail);
                }
                location.href = data.redirectUrl;
            }
        },
        error: function (data) {
            if (data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
            } else {
                if (data.responseJSON.message) {
                    createErrorNotification($('.error-messaging'), data.responseJSON.message);
                }
                $('form.login').trigger('login:error', data);
                $form.spinner().stop();
            }
        }
    });
}

/**
 * Submits the track order form to the Order-Track route
 * @param {JQuery} $form - the track order form as a jQuery object
 * @param {string} url - the Order-Track route's url
 */
function trackOrder($form, url) {
    var isValid = true;
    var $errorDiv = $form.find('.track-order-form-error');
    var $errorAlert = $form.find('#track-order-form-error');

    $errorDiv.hide();

    $form.find('input:visible').each(function () {
        if (this.checkValidity && !this.checkValidity()) {
            $(this).trigger('invalid', this.validity);
            isValid = false;
        }
    });

    if (!isValid) {
        $form.trigger('error:scrollToError');
        return;
    }

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serializeArray(),
        success: function (data) {
            $form.spinner().stop();
            if (data.orderTrackFormError) {
                $errorDiv.show();
                $errorAlert.attr('tabindex', '-1').focus();
                return;
            }

            if (data.url) {
                location.href = data.url;
            }
        },
        error: function () {
            $form.spinner().stop();
            $errorDiv.show();
            $errorAlert.attr('tabindex', '-1').focus();
        }
    });
}

/**
 * Validate registration form fields before AJAX submit.
 * @param {jQuery} $form - registration form
 * @returns {boolean} whether form is valid
 */
function validateRegistrationForm($form) {
    var isValid = true;

    $form.find('input:visible, select:visible').each(function () {
        if (this.checkValidity && !this.checkValidity()) {
            $(this).trigger('invalid', this.validity);
            isValid = false;
        }
    });

    return isValid;
}

/**
 * Submits the registration form to the Account-SubmitRegistration route
 * @param {JQuery} $form - the registration form as a jQuery object
 * @param {string} url - the Account-SubmitRegistration route's url
 */
function register($form, url) {
    let formData = $form.serializeArray();
    let embroideryTemplatesData;

    // If guest user has saved embroidery templates send the data for saving on profile
    if (window.localStorage.getItem('savedEmbroideryTemplates')) {
        embroideryTemplatesData = embroidery.validateStoredTemplates();
        if (embroideryTemplatesData.length) {
            formData.push({
                name: 'savedEmbroideryTemplates',
                value: JSON.stringify(embroideryTemplatesData)
            });
        }
    }

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: formData,
        success: function (data) {
            $form.spinner().stop();
            if (!data.success) {
                $('form.registration').trigger('login:register:error', data);
                formValidation($form, data);
                // handle the display error for confirm password field
                if (data.fields && data.fields.dwfrm_profile_login_passwordconfirm) {
                    var feedbackElement = $($form).find('[name="dwfrm_profile_login_passwordconfirm"]')
                        .parent()
                        .siblings('.invalid-feedback');
                    if (feedbackElement.length > 0) {
                        feedbackElement.html(data.fields.dwfrm_profile_login_passwordconfirm);
                    }
                    feedbackElement.siblings('.position-relative').addClass('is-invalid');
                    feedbackElement.siblings('.position-relative').children('.form-control').addClass('is-invalid');

                    feedbackElement = $($form).find('[name="dwfrm_profile_login_password"]')
                        .parent()
                        .siblings('.invalid-feedback');
                    feedbackElement.siblings('.position-relative').addClass('is-invalid');
                    feedbackElement.siblings('.position-relative').children('.form-control').addClass('is-invalid');
                }
                $('form.registration').trigger('error:scrollToError');
            } else {
                // Delete guest saved templates upon logging in
                if (embroideryTemplatesData) {
                    window.localStorage.removeItem('savedEmbroideryTemplates');
                }
                $('form.registration').trigger('login:register:success', data);
                location.href = data.redirectUrl;
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification($('.error-messaging'), err.responseJSON.message);
                $('form.registration').trigger('error:scrollToError');
            }

            $form.spinner().stop();
        }
    });
}

/**
 * Announces password reset status updates to screen readers via the modal live region.
 * @param {string} message - Text to announce
 */
function announcePasswordResetStatus(message) {
    $('#requestPasswordResetStatus').text(message);
}

/**
 * Updates the forgot-password modal with a success message and announces it to screen readers.
 * @param {Object} data - Password reset success response from Account-PasswordResetDialogForm
 */
function announcePasswordResetSuccess(data) {
    var $title = $('#requestPasswordResetModalTitle');
    var $form = $('#email-form');
    var announcement = data.receivedMsgHeading + '. ' + data.receivedMsgBody;
    var $focusTarget;

    $title.text(data.receivedMsgHeading);
    $('.request-password-body').empty()
        .append('<p id="requestPasswordResetModalDescription">' + data.receivedMsgBody + '</p>');

    if (!data.mobile) {
        $focusTarget = $('#submitEmailButton').text(data.buttonText)
            .attr('data-dismiss', 'modal')
            .prop('disabled', false);
    } else {
        $('.send-email-btn').empty()
            .html('<a href="'
                + data.returnUrl
                + '" class="btn btn-primary btn-block">'
                + data.buttonText + '</a>'
            );
        $focusTarget = $('.send-email-btn a');
    }

    $form.removeAttr('aria-busy');
    announcePasswordResetStatus(announcement);
    $focusTarget.focus();
}

module.exports = $.extend(base, {
    scrollToRegistration: function () {
        if (window.location.hash === '#registration' && window.matchMedia('(max-width: 992px)').matches) {
            $('html, body').animate({
                scrollTop: ($('#registerCard').offset().top - 150)
            }, 500);
        }
    },

    login: function () {
        $('form.login').submit(function (e) {
            e.preventDefault();
            var $form = $(this);
            var url = $form.attr('action');
            $form.spinner().start();
            $('form.login').trigger('login:submit', e);

            var $recaptcha = $(this).find('[name="g-recaptcha-response"]');
            if ($recaptcha.length) {
                var siteKey = $recaptcha.data('sitekey');
                var action = $form.find('[name="g-recaptcha-action"]').val();
                var recaptchExecCB = function (token) { // eslint-disable-line
                    $recaptcha.val(token);
                    login($form, url);
                };
                if (grecaptcha.enterprise) { // eslint-disable-line
                    grecaptcha.enterprise.ready(function () { // eslint-disable-line
                        grecaptcha.enterprise.execute(siteKey, { action: action }).then(recaptchExecCB); // eslint-disable-line
                    });
                } else {
                    grecaptcha.ready(function () { // eslint-disable-line
                        grecaptcha.execute(siteKey, { action: action }).then(recaptchExecCB); // eslint-disable-line
                    });
                }
            } else {
                login($form, url);
            }
        });
    },

    register: function () {
        $('form.registration').submit(function (e) {
            e.preventDefault();
            var $form = $(this);
            var url = $form.attr('action');

            if (!validateRegistrationForm($form)) {
                $form.trigger('error:scrollToError');
                return false;
            }

            $form.spinner().start();
            $('form.registration').trigger('login:register', e);

            var $recaptcha = $(this).find('[name="g-recaptcha-response"]');
            if ($recaptcha.length) {
                var siteKey = $recaptcha.data('sitekey');
                var action = $form.find('[name="g-recaptcha-action"]').val();
                var recaptchExecCB = function (token) { // eslint-disable-line
                    $recaptcha.val(token);
                    register($form, url);
                };
                if (grecaptcha.enterprise) { // eslint-disable-line
                    grecaptcha.enterprise.ready(function () { // eslint-disable-line
                        grecaptcha.enterprise.execute(siteKey, { action: action }).then(recaptchExecCB); // eslint-disable-line
                    });
                } else {
                    grecaptcha.ready(function () { // eslint-disable-line
                        grecaptcha.execute(siteKey, { action: action }).then(recaptchExecCB); // eslint-disable-line
                    });
                }
            } else {
                register($form, url);
            }
            return false;
        });
        $('#registration-form-password-confirm').on('keyup', function (e) {
            e.preventDefault();
            var currElement = $(this).parent();
            currElement.removeClass('is-invalid');
        });
    },

    trackOrder: function () {
        $('.track-order-button').on('click', function (e) {
            e.preventDefault();
            var $form = $(this).closest('form');
            var url = $form.attr('action');
            $form.spinner().start();

            var $recaptcha = $form.find('[name="g-recaptcha-response"]');
            if ($recaptcha.length) {
                var siteKey = $recaptcha.data('sitekey');
                var action = $form.find('[name="g-recaptcha-action"]').val();
                var recaptchExecCB = function (token) { // eslint-disable-line
                    $recaptcha.val(token);
                    $form.spinner().stop();
                    trackOrder($form, url);
                };
                if (grecaptcha.enterprise) { // eslint-disable-line
                    grecaptcha.enterprise.ready(function () { // eslint-disable-line
                        grecaptcha.enterprise.execute(siteKey, { action: action }).then(recaptchExecCB); // eslint-disable-line
                    });
                } else {
                    grecaptcha.ready(function () { // eslint-disable-line
                        grecaptcha.execute(siteKey, { action: action }).then(recaptchExecCB); // eslint-disable-line
                    });
                }
            } else {
                $form.spinner().stop();
                trackOrder($form, url);
            }
        });
    },

    showPassword: function () {
        $('.show-password').on('click', function (e) {
            e.preventDefault();
            var passVal = $(this).siblings('input');
            var labelShow = $(this).data('label-show');
            var labelHide = $(this).data('label-hide');
            if (passVal.attr('type') === 'password') {
                passVal.attr('type', 'text');
                $(this).html(labelHide);
            } else {
                passVal.attr('type', 'password');
                $(this).html(labelShow);
            }
        });
    },

    clearResetForm: function () {
        $('#requestPasswordResetModal').on('hidden.bs.modal', function () {
            var $form = $('#email-form');
            $('#reset-password-email').val('');
            $form.removeAttr('aria-busy');
            $('#submitEmailButton').prop('disabled', false);
            $form.find('.form-control.is-invalid').removeClass('is-invalid').removeAttr('aria-invalid');
            $form.find('.invalid-feedback').empty();
            $('#requestPasswordResetStatus').empty();
        });
    },

    resetPassword: function () {
        $('.reset-password-form').on('submit', function (e) {
            e.preventDefault();
            var $form = $(this);
            var url = $form.attr('action');
            var isValid = true;

            $form.find('input, select').each(function () {
                if (this.checkValidity && !this.checkValidity()) {
                    $(this).trigger('invalid', this.validity);
                    isValid = false;
                }
            });

            if (!isValid) {
                $form.trigger('error:scrollToError');
                return false;
            }

            $form.spinner().start();
            $form.attr('aria-busy', 'true');
            $('#submitEmailButton').prop('disabled', true);
            var $status = $('#requestPasswordResetStatus');
            announcePasswordResetStatus($status.attr('data-submitting-msg'));
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        $form.removeAttr('aria-busy');
                        $('#submitEmailButton').prop('disabled', false);
                        formValidation($form, data);
                        $form.trigger('error:scrollToError');
                    } else {
                        announcePasswordResetSuccess(data);
                    }
                },
                error: function () {
                    $form.spinner().stop();
                    $form.removeAttr('aria-busy');
                    $('#submitEmailButton').prop('disabled', false);
                }
            });
            return false;
        });
    },

    focusPasswordResetModal: function () {
        $('body').on('click', '#password-reset', function () {
            passwordResetTrigger = this;
        });

        $('body').on('shown.bs.modal', '#requestPasswordResetModal', function () {
            var $modal = $('#requestPasswordResetModal');

            passwordResetAriaHiddenElements = [];
            $('body').children().each(function () {
                var $el = $(this);
                if ($el.is($modal) || $el.hasClass('modal-backdrop')) {
                    return;
                }
                if ($el.attr('aria-hidden') !== 'true') {
                    passwordResetAriaHiddenElements.push($el);
                    $el.attr('aria-hidden', 'true');
                }
            });

            $modal.find('#reset-password-email').focus();
        });
    },

    onClosingPasswordResetModal: function () {
        $('body').on('hidden.bs.modal', '#requestPasswordResetModal', function () {
            passwordResetAriaHiddenElements.forEach(function ($el) {
                $el.attr('aria-hidden', 'false');
            });
            passwordResetAriaHiddenElements = [];

            if (passwordResetTrigger) {
                passwordResetTrigger.focus();
                passwordResetTrigger = null;
            }
        });
    },

    trapPasswordResetModalFocus: function () {
        $('body').on('keydown', '#requestPasswordResetModal', function (e) {
            if (e.key === 'Escape') {
                $('#requestPasswordResetModal').modal('hide');
                return;
            }

            var isTab = e.key === 'Tab' || e.keyCode === 9;
            if (!isTab) {
                return;
            }

            var $modal = $('#requestPasswordResetModal');
            // Desired cycle (not DOM order): email → Send → close → email
            var $focusables = $modal.find('#reset-password-email, #submitEmailButton, .close')
                .filter(':visible:not([disabled])');
            if (!$focusables.length) {
                return;
            }

            var focusedIndex = $focusables.index(document.activeElement);
            var nextIndex;

            if (e.shiftKey) {
                nextIndex = focusedIndex <= 0 ? $focusables.length - 1 : focusedIndex - 1;
            } else {
                nextIndex = focusedIndex >= $focusables.length - 1 ? 0 : focusedIndex + 1;
            }

            e.preventDefault();
            $focusables.eq(nextIndex).focus();
        });
    }
});
